import { IconKey,IconUserSearch,IconCode } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconUserSearch,
    IconCode
};
//

const Dev = {

    id: 'authentication',
    title: 'Dev',
    type: 'group',
    display_id:'X',
    icon: icons.IconCode,
    children: [
        {
            id: 'logs',
            title: 'Log Monitoring',
            type: 'item',
            display_id:115,
            url: '/dev/logs',
            breadcrumbs: false
        },
        {
            id: 'delete_user',
            title: 'Delete User',
            type: 'item',
            display_id:119,
            url: '/dev/delete_user',
            breadcrumbs: false
        },
        {
            id: 'email_content',
            title: 'Email Content',
            type: 'item',
            display_id:122,
            url: '/Admin/email_content',
            breadcrumbs: false
        },
    ]
}

export default Dev;
